import React from 'react'
import { FriendTookActionMetadata } from '../../../types/notifications'
import {
  NotificationRowProps,
  NotificationRowShell,
  UserAvatarCircle
} from './notification-row-shell'

const FriendTookActionRow = (props: NotificationRowProps) => {
  const meta = props.notification.metadata as Partial<FriendTookActionMetadata> | undefined

  return (
    <NotificationRowShell
      {...props}
      avatar={<UserAvatarCircle src={meta?.user_avatar} />}
      destination={meta?.action_slug ? `/action/${meta.action_slug}` : undefined}
      highlights={[meta?.user_name, meta?.action_name]}
    />
  )
}

export default FriendTookActionRow
